var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightOutlined = function SvgArrowRightOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.45,
    d: "M13.578 7.622 7.675 2.498a.25.25 0 0 0-.164-.06H6.128a.124.124 0 0 0-.081.218l5.472 4.75H2.375a.125.125 0 0 0-.125.125v.938c0 .069.056.125.125.125h9.142l-5.472 4.75a.124.124 0 0 0 .082.219h1.43c.029 0 .059-.011.08-.032l5.941-5.153a.5.5 0 0 0 0-.756Z"
  })));
};
export default SvgArrowRightOutlined;